<template>
    <div>
        <b-card :title="addEditTitle" :sub-title="addEditSubTitle">
            <step-wizard :tabs="stepWizard" :maxTabIndex="editRegistrationStepIndex"
                         :actTabIndex="step" @stepChanged="stepChanged" class="mt-4"
            />

            <b-alert :show="err" :variant="errVariant" class="mb-3">{{errText}}</b-alert>
            <b-form v-show="step===-1" @submit.prevent="saveRecord" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12" v-if="userActionAccessCompany">
                        <b-form-group label="РЭК" label-for="select-edit-company" class="required">
                            <b-select id="select-edit-company" :options="editCompanies" v-model="editCompanyUid"
                                      ref="selectEditCompany" :disabled="recordUid.length!==0 || getEditControlStatus"
                                      @change="loadRes"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group v-if="userActionAccessRes" label="РЭС" label-for="select-edit-res"
                                      class="required">
                            <b-select id="select-edit-res" :options="editRes" v-model="editResUid"
                                      ref="selectEditRes" @change="selectEditResChanged"
                                      :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col :md="(userActionAccessRes) ? 6 : 12">
                        <b-form-group label="Ответственный сотрудник" label-for="select-edit-responsible-user"
                                      class="required">
                            <b-select id="select-edit-responsible-user" :options="editResponsibleUsers"
                                      v-model="editResponsibleUserUid" :disabled="getEditControlStatus"
                                      ref="selectEditResponsibleUser" @change="selectEditResponsibleUserChanged"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Заявитель" label-for="input-edit-subscriber" class="required">
                            <b-input id="input-edit-subscriber" v-model="editSubscriber" @keyup.esc="cancelRecord"
                                     maxlength="200" ref="inputEditSubscriber" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label="Телефон(ы)" label-for="input-edit-phone-numbers" class="required">
                            <b-input id="input-edit-phone-numbers" v-model="editPhoneNumbers" @keyup.esc="cancelRecord"
                                     maxlength="40" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Адрес" label-for="input-edit-address" class="required">
                            <b-input id="input-edit-address" v-model="editAddress" @keyup.esc="cancelRecord"
                                     maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description">
                            <b-textarea id="textarea-edit-description" v-model="editDescription" rows="2"
                                        maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <div v-show="recordUid.length===0" class="alert alert-secondary pointer"
                             @click.prevent="saveRecord">
                            Нажмите сюда, чтобы сохранить запись и начать загрузку документов
                        </div>
                    </b-col>
                    <b-col md="12" v-show="recordUid.length>0 && attachments.length>0">
                        <h5>Документы для загрузки</h5>
                    </b-col>
                    <b-col v-show="recordUid.length>0" v-for="attachment in attachments" :key="attachment.FileName"
                           md="3">
                        <image-uploader :attachment="attachment" attachmentFor="NewSubscriberRegistrationAttachment"
                                        :recordUid="recordUid" :attachmentParams="attachmentParams"
                                        :disabled="getEditControlStatus" width="100%" height="120px"
                                        :showPreviewButton=true :showDownloadButton=true :showTitle=true
                                        labelText="Кликните сюда для загрузки файла"
                                        @getDownloadStatus="getDownloadStatus"
                        />
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button v-show="!getEditControlStatus && editRegistrationStatusUid!==6" type="submit"
                              class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button variant="secondary" class="mt-2" title="Печатать бланк"
                              :disabled="editDocBlankUid===-1" @click="generateBlank('kg')"
                    >
                        <i class="fa fa-print"/> Бланк кырг.
                    </b-button>
                    <b-button variant="secondary" class="ml-2 mt-2" title="Печатать бланк"
                              :disabled="editDocBlankUid===-1" @click="generateBlank('ru')"
                    >
                        <i class="fa fa-print"/> Бланк рус.
                    </b-button>

                    <b-button v-show="editRegistrationStepIndex===-1 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Передать заявку на следующий шаг"
                              @click="buttonNextStepClicked"
                    >
                        Передать заявку <i class="fa fa-arrow-right"/>
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

            <b-form v-show="step===1" @submit.prevent="saveRecordStep" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Ответственный сотрудник" label-for="select-edit-responsible-user-step-1"
                                      class="required">
                            <b-select id="select-edit-responsible-user-step-1" :options="editResponsibleUsersStep1"
                                      v-model="editDataJsonStep1.ResponsibleUser_UID" :disabled="getEditControlStatus"
                                      ref="selectEditResponsibleUserStep0"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description-step-1">
                            <b-textarea id="textarea-edit-description-step-1" v-model="editDataJsonStep1.Description"
                                        rows="2" maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button v-show="!getEditControlStatus && editRegistrationStatusUid!==6"
                              type="submit" class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button v-show="editRegistrationStepIndex===1 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Передать заявку на следующий шаг"
                              @click="buttonNextStepClicked"
                    >
                        Передать заявку <i class="fa fa-arrow-right"/>
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===1 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Вернуть заявку на предыдущий шаг"
                              @click="buttonPreviousStepClicked"
                    >
                        <i class="fa fa-arrow-left"/> Вернуть заявку
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===1 && userActionStepSwitchAccess" variant="danger"
                              class="ml-2 mt-2 float-right" title="Отклонить заявку"
                              @click="buttonCancelStepClicked"
                    >
                        <i class="fa fa-ban"/> Отклонить
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

            <b-form v-show="step===2" @submit.prevent="saveRecordStep" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Ответственный сотрудник" label-for="select-edit-responsible-users-step-2"
                                      class="required">
                            <b-select id="select-edit-responsible-users-step-2" :options="editResponsibleUsersStep2"
                                      v-model="editDataJsonStep2.ResponsibleUser_UID"
                                      ref="selectEditResponsibleUsersStep1"
                                      :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Подстанция" label-for="select-edit-res-substations-step-2"
                                      class="required">
                            <b-select id="select-edit-res-substations-step-2" :options="editResSubstationsStep2"
                                      v-model="editDataJsonStep2.RESSubstation_UID"
                                      ref="selectEditResSubstationsStep1" @change="selectEditResSubstationsChanged"
                                      :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Фидер" label-for="select-edit-res-feeders-step-2"
                                      class="required">
                            <b-select id="select-edit-res-feeders-step-2" :options="editResFeedersStep2"
                                      v-model="editDataJsonStep2.RESFeeder_UID"
                                      ref="selectEditResFeedersStep1" @change="selectEditResFeedersChanged"
                                      :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="ТП РЭС" label-for="select-edit-res-tr-substations-step-2"
                                      class="required">
                            <b-select id="select-edit-res-tr-substations-step-2" :options="editResTrSubstationsStep2"
                                      v-model="editDataJsonStep2.RESTrSubstation_UID"
                                      ref="selectEditResTrSubstationsStep1"
                                      :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Опора" label-for="input-edit-prop-step-2" class="required">
                            <b-input id="input-edit-prop-step-2" v-model="editDataJsonStep2.Prop"
                                     @keyup.esc="cancelRecord"
                                     maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Мощность" label-for="input-edit-power-step-2" class="required">
                            <b-input id="input-edit-power-step-2" v-model="editDataJsonStep2.Power"
                                     @keyup.esc="cancelRecord"
                                     maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4">
                        <b-form-group label="Напряжение" label-for="input-edit-voltage-step-2" class="required">
                            <b-input id="input-edit-voltage-step-2" v-model="editDataJsonStep2.Voltage"
                                     @keyup.esc="cancelRecord"
                                     maxlength="20" disabled="disabled"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description-step-2">
                            <b-textarea id="textarea-edit-description-step-2" v-model="editDataJsonStep2.Description"
                                        rows="2"
                                        maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button v-show="!getEditControlStatus && editRegistrationStatusUid!==6" type="submit"
                              class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button v-show="editRegistrationStepIndex===2 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Передать заявку на следующий шаг"
                              @click="buttonNextStepClicked"
                    >
                        Передать заявку <i class="fa fa-arrow-right"/>
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===2 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Вернуть заявку на предыдущий шаг"
                              @click="buttonPreviousStepClicked"
                    >
                        <i class="fa fa-arrow-left"/> Вернуть заявку
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===2 && userActionStepSwitchAccess" variant="danger"
                              class="ml-2 mt-2 float-right" title="Отклонить заявку"
                              @click="buttonCancelStepClicked"
                    >
                        <i class="fa fa-ban"/> Отклонить
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

            <b-form v-show="step===3" @submit.prevent="saveRecordStep" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Ответственный сотрудник" label-for="select-edit-responsible-user-step-3"
                                      class="required">
                            <b-select id="select-edit-responsible-user-step-3" :options="editResponsibleUsersStep3"
                                      v-model="editDataJsonStep3.ResponsibleUser_UID" :disabled="getEditControlStatus"
                                      ref="selectEditResponsibleUserStep2"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description-step-3">
                            <b-textarea id="textarea-edit-description-step-3" v-model="editDataJsonStep3.Description"
                                        rows="2" maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" v-show="attachmentsStep3.length>0">
                        <h5>Документы для загрузки</h5>
                    </b-col>
                    <b-col v-for="attachment in attachmentsStep3" :key="attachment.FileName" md="3">
                        <image-uploader :attachment="attachment"
                                        attachmentFor="NewSubscriberRegistration_US_TP_Step3_Attachment"
                                        :recordUid="recordUid" :attachmentParams="attachmentParamsStep3"
                                        :disabled="getEditControlStatus" width="100%" height="120px"
                                        :showPreviewButton=true :showDownloadButton=true :showTitle=true
                                        labelText="Кликните сюда для загрузки файла"
                                        @getDownloadStatus="getDownloadStatus"
                        />
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button v-show="!getEditControlStatus && editRegistrationStatusUid!==6" type="submit"
                              class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button v-show="editRegistrationStepIndex===3 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Передать заявку на следующий шаг"
                              @click="buttonNextStepClicked"
                    >
                        Передать заявку <i class="fa fa-arrow-right"/>
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===3 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Вернуть заявку на предыдущий шаг"
                              @click="buttonPreviousStepClicked"
                    >
                        <i class="fa fa-arrow-left"/> Вернуть заявку
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===3 && userActionStepSwitchAccess" variant="danger"
                              class="ml-2 mt-2 float-right" title="Отклонить заявку"
                              @click="buttonCancelStepClicked"
                    >
                        <i class="fa fa-ban"/> Отклонить
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

            <b-form v-show="step===4" @submit.prevent="saveRecordStep" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Ответственный сотрудник" label-for="select-edit-responsible-user-step-4"
                                      class="required">
                            <b-select id="select-edit-responsible-user-step-4" :options="editResponsibleUsersStep4"
                                      v-model="editDataJsonStep4.ResponsibleUser_UID" :disabled="getEditControlStatus"
                                      ref="selectEditResponsibleUserStep3"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description-step-4">
                            <b-textarea id="textarea-edit-description-step-4" v-model="editDataJsonStep4.Description"
                                        rows="2" maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" v-show="attachmentsStep4.length>0">
                        <h5>Документы для загрузки</h5>
                    </b-col>
                    <b-col v-for="attachment in attachmentsStep4" :key="attachment.FileName" md="3">
                        <image-uploader :attachment="attachment"
                                        attachmentFor="NewSubscriberRegistration_US_TP_Step4_Attachment"
                                        :recordUid="recordUid" :attachmentParams="attachmentParamsStep4"
                                        :disabled="getEditControlStatus" width="100%" height="120px"
                                        :showPreviewButton=true :showDownloadButton=true :showTitle=true
                                        labelText="Кликните сюда для загрузки файла"
                                        @getDownloadStatus="getDownloadStatus"
                        />
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button v-show="!getEditControlStatus && editRegistrationStatusUid!==6" type="submit"
                              class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button v-show="editRegistrationStepIndex===4 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Передать заявку на следующий шаг"
                              @click="buttonNextStepClicked"
                    >
                        Передать заявку <i class="fa fa-arrow-right"/>
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===4 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Вернуть заявку на предыдущий шаг"
                              @click="buttonPreviousStepClicked"
                    >
                        <i class="fa fa-arrow-left"/> Вернуть заявку
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===4 && userActionStepSwitchAccess" variant="danger"
                              class="ml-2 mt-2 float-right" title="Отклонить заявку"
                              @click="buttonCancelStepClicked"
                    >
                        <i class="fa fa-ban"/> Отклонить
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

            <b-form v-show="step===5" @submit.prevent="saveRecordStep" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Ответственный сотрудник" label-for="select-edit-responsible-user-step-5"
                                      class="required">
                            <b-select id="select-edit-responsible-user-step-5" :options="editResponsibleUsersStep5"
                                      v-model="editDataJsonStep5.ResponsibleUser_UID" :disabled="getEditControlStatus"
                                      ref="selectEditResponsibleUserStep4"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description-step-5">
                            <b-textarea id="textarea-edit-description-step-5" v-model="editDataJsonStep5.Description"
                                        rows="2" maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button v-show="!getEditControlStatus && editRegistrationStatusUid!==6" type="submit"
                              class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button v-show="editRegistrationStepIndex===5 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Передать заявку на следующий шаг"
                              @click="buttonNextStepClicked"
                    >
                        Передать заявку <i class="fa fa-arrow-right"/>
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===5 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Вернуть заявку на предыдущий шаг"
                              @click="buttonPreviousStepClicked"
                    >
                        <i class="fa fa-arrow-left"/> Вернуть заявку
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===5 && userActionStepSwitchAccess" variant="danger"
                              class="ml-2 mt-2 float-right" title="Отклонить заявку"
                              @click="buttonCancelStepClicked"
                    >
                        <i class="fa fa-ban"/> Отклонить
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

            <b-form v-show="step===6" @submit.prevent="saveRecordStep" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Ответственный сотрудник"
                                      label-for="select-edit-responsible-user-step-6"
                                      class="required">
                            <b-select id="select-edit-responsible-user-step-6" :options="editResponsibleUsersStep6"
                                      v-model="editDataJsonStep6.ResponsibleUser_UID" :disabled="getEditControlStatus"
                                      ref="selectEditResponsibleUserStep5"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="ПУ" class="required">
                            <v-select2 label="Device" :filterable="false" class="select2"
                                       :reduce="user => user.UID"
                                       :options="editSrpuRpDevicesStep6" v-model="editDataJsonStep6.RPDevice_UID"
                                       @search="fetchSrpuRpDevices" :disabled="getEditControlStatus"
                            >
                                <template slot="no-options">
                                    Введите для поиска ПУ..
                                </template>
                            </v-select2>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Пломба крышки" label-for="input-edit-seal-cap-step-6" class="required">
                            <b-input id="input-edit-seal-cap-step-6" v-model="editDataJsonStep6.SealCap"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Пломба на ящике" label-for="input-edit-seal-box-step-6">
                            <b-input id="input-edit-seal-box-step-6" v-model="editDataJsonStep6.SealBox"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Коэффициент трансформации" class="required"
                                      label-for="input-edit-transformation-coefficient-step-6">
                            <b-input id="input-edit-transformation-coefficient-step-6"
                                     v-model="editDataJsonStep6.TransformationCoefficient"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="3">
                        <b-form-group label="Одноразовая пломба"
                                      label-for="input-edit-seal-one-off-step-6">
                            <b-input id="input-edit-seal-one-off-step-6" v-model="editDataJsonStep6.SealOneOff"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Пломба ТТ"
                                      label-for="input-edit-seal-tt-step-6">
                            <b-input id="input-edit-seal-tt-step-6" v-model="editDataJsonStep6.SealTT"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Пломба щит ТТ"
                                      label-for="input-edit-seal-tt-shield-step-6">
                            <b-input id="input-edit-seal-tt-shield-step-6" v-model="editDataJsonStep6.SealTTShield"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Пломба ТН"
                                      label-for="input-edit-seal-tn-shield-step-6">
                            <b-input id="input-edit-seal-tn-shield-step-6" v-model="editDataJsonStep6.SealTNShield"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Пломба РТН"
                                      label-for="input-edit-seal-rt-step-6">
                            <b-input id="input-edit-seal-rt-step-6" v-model="editDataJsonStep6.SealRT"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Пломба АВ ТН"
                                      label-for="input-edit-seal-abtn-step-6">
                            <b-input id="input-edit-seal-abtn-step-6" v-model="editDataJsonStep6.SealABTN"
                                     @keyup.esc="cancelRecord" maxlength="20" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>


                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description-step-6">
                            <b-textarea id="textarea-edit-description-step-6" v-model="editDataJsonStep6.Description"
                                        rows="2"
                                        maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12" v-show="attachmentsStep6.length>0">
                        <h5>Документы для загрузки</h5>
                    </b-col>
                    <b-col v-for="attachment in attachmentsStep6" :key="attachment.FileName" md="3">
                        <image-uploader :attachment="attachment"
                                        attachmentFor="NewSubscriberRegistration_US_TP_Step6_Attachment"
                                        :recordUid="recordUid" :attachmentParams="attachmentParamsStep6"
                                        :disabled="getEditControlStatus" width="100%" height="120px"
                                        :showPreviewButton=true :showDownloadButton=true :showTitle=true
                                        labelText="Кликните сюда для загрузки файла"
                                        @getDownloadStatus="getDownloadStatus"
                        />
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button v-show="!getEditControlStatus && editRegistrationStatusUid!==6" type="submit"
                              class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button v-show="editRegistrationStepIndex===6 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Передать заявку на следующий шаг"
                              @click="buttonNextStepClicked"
                    >
                        Передать заявку <i class="fa fa-arrow-right"/>
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===6 && userActionStepSwitchAccess" variant="success"
                              class="ml-2 mt-2 float-right" title="Вернуть заявку на предыдущий шаг"
                              @click="buttonPreviousStepClicked"
                    >
                        <i class="fa fa-arrow-left"/> Вернуть заявку
                    </b-button>
                    <b-button v-show="editRegistrationStepIndex===6 && userActionStepSwitchAccess" variant="danger"
                              class="ml-2 mt-2 float-right" title="Отклонить заявку"
                              @click="buttonCancelStepClicked"
                    >
                        <i class="fa fa-ban"/> Отклонить
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

            <b-form v-show="step===7" @submit.prevent="saveRecordStep" @reset.prevent="cancelRecord">
                <b-row>
                    <b-col md="12">
                        <b-form-group label="Тариф абонента"
                                      label-for="select-edit-subscriber-rate-step-7"
                                      class="required">
                            <b-select id="select-edit-subscriber-rate-step-7" :options="editSubscriberRatesStep7"
                                      v-model="editDataJsonStep7.SubscriberRate_UID" :disabled="getEditControlStatus"
                                      ref="selectEditSubscriberRatesStep6"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="12">
                        <b-form-group label="Примечание" label-for="textarea-edit-description-step-7">
                            <b-textarea id="textarea-edit-description-step-7" v-model="editDataJsonStep7.Description"
                                        rows="2"
                                        maxlength="200" :disabled="getEditControlStatus"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <b-button
                            v-show="!getEditControlStatus && editRegistrationStatusUid!==6 && editRegistrationStatusUid!==11"
                            type="submit" class="mt-2" variant="primary"
                    >
                        Сохранить
                    </b-button>
                    <b-button type="reset" variant="secondary" class="ml-2 mt-2 mr-5" :disabled="fileDownloadCounter>0">
                        Закрыть
                    </b-button>

                    <b-button
                            v-show="editRegistrationStepIndex===7 && userActionStepSwitchAccess && editRegistrationStatusUid!==11"
                            variant="primary" class="ml-2 mt-2 float-right" title="Закрыть заявку"
                            @click="buttonCloseStepClicked"
                    >
                        <i class="fa fa-check"/> Закрыть заявку
                    </b-button>
                    <b-button
                            v-show="editRegistrationStepIndex===7 && userActionStepSwitchAccess && editRegistrationStatusUid!==11"
                            variant="success" class="ml-2 mt-2 float-right" title="Вернуть заявку на предыдущий шаг"
                            @click="buttonPreviousStepClicked"
                    >
                        <i class="fa fa-arrow-left"/> Вернуть заявку
                    </b-button>
                    <b-button
                            v-show="editRegistrationStepIndex===7 && userActionStepSwitchAccess && editRegistrationStatusUid!==11"
                            variant="danger" class="ml-2 mt-2 float-right" title="Отклонить заявку"
                            @click="buttonCancelStepClicked"
                    >
                        <i class="fa fa-ban"/> Отклонить
                    </b-button>
                </div>
                <b-alert :show="editRecordSavedMessage.length>0" variant="info" class="mt-3">
                    {{editRecordSavedMessage}}
                </b-alert>
            </b-form>

        </b-card>

        <b-modal ref="modal-finished" hide-footer hide-header centered @hidden="cancelRecord">
            <p class="text-center font-weight-bolder">Заявка передана на обработку</p>
            <b-button variant="secondary" class="mt-5 ml-auto mr-auto d-block" @click="cancelRecord">Закрыть</b-button>
        </b-modal>

        <b-modal ref="modal-next-step-confirmation" hide-footer hide-header centered>
            <p class="text-center">Вы действительно желаете ПЕРЕДАТЬ заявку на следующий шаг?</p>
            <div class="d-flex flex-row flex-center">
                <b-button variant="primary" @click="buttonNextStepConfirmOkClicked" class="w-80px">ОК</b-button>
                <b-button variant="secondary" @click="buttonNextStepConfirmCancelClicked" class="ml-3 w-80px">Отмена
                </b-button>
            </div>
        </b-modal>
        <b-modal ref="modal-close-step-confirmation" hide-footer hide-header centered>
            <p class="text-center">Вы действительно желаете ЗАКРЫТЬ заявку?</p>
            <div class="d-flex flex-row flex-center">
                <b-button variant="primary" @click="buttonCloseStepConfirmOkClicked" class="w-80px">ОК</b-button>
                <b-button variant="secondary" @click="buttonCloseStepConfirmCancelClicked" class="ml-3 w-80px">Отмена
                </b-button>
            </div>
        </b-modal>
        <b-modal ref="modal-previous-step-confirmation" hide-footer hide-header centered>
            <p class="text-center">Вы действительно желаете ВЕРНУТЬ заявку на предыдущий шаг?</p>
            <div class="d-flex flex-row flex-center">
                <b-button variant="primary" @click="buttonPreviousStepConfirmOkClicked" class="w-80px">ОК</b-button>
                <b-button variant="secondary" @click="buttonPreviousStepConfirmCancelClicked" class="ml-3 w-80px">
                    Отмена
                </b-button>
            </div>
        </b-modal>
        <b-modal ref="modal-cancel-step-confirmation" hide-footer hide-header centered>
            <p class="text-center">Вы действительно желаете ОТКЛОНИТЬ заявку?</p>
            <div class="d-flex flex-row flex-center">
                <b-button variant="primary" @click="buttonCancelStepConfirmOkClicked" class="w-80px">ОК</b-button>
                <b-button variant="secondary" @click="buttonCancelStepConfirmCancelClicked" class="ml-3 w-80px">Отмена
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import ImageUploader from "@/view/components/ImageUploader";
    import StepWizard from "@/view/components/StepWizard";
    import axios from "axios";
    import {debounce} from "../../../assets/js/components/debounce";

    export default {
        name: "NewSubscriberUpdate1",
        components: {ImageUploader, StepWizard},
        data() {
            return {
                userData: this.$store.getters.getUserData,

                err: false,
                errText: "",
                errVariant: "danger",

                userActionAccessArray: [],
                userActionAccessCompany: false,
                userActionAccessRes: false,
                userActionStepSwitchAccess: false,
                userActionStepEditAccess: false,

                loadProcessing: 0,

                recordUid: "",
                recordVersion: "",
                recordRegistrationTypeUid: 1,

                addEditTitle: "",
                addEditSubTitle: "",
                editRecordSavedMessageTimer: null,
                editRecordSavedMessage: "",

                editCompanies: [],
                editRes: [],
                editRegistrationStatuses: [],

                editRegistrationType: "",
                editDocBlankUid: -1,
                editCompanyUid: 0,
                editResUid: "",
                editSubscriber: "",
                editAddress: "",
                editPhoneNumbers: "",
                editRegistrationNum: "",
                editFullRegistrationNum: "",
                editDescription: "",
                editRegistrationStatusUid: 0,
                editRegistrationStepUid: -1,
                editRegistrationStepIndex: -1,

                editResponsibleUserUid: "",
                editResponsibleUsers: [],

                attachments: [],
                attachmentParams: {},

                //Step1
                //editDescriptionStep1: "",
                //editResponsibleUserUidStep1: "",
                editDataJsonStep1: {
                    ResponsibleUser_UID: "",
                    Description: "",
                },
                editResponsibleUsersStep1: [],

                //Step2
                //editDescriptionStep2: "",
                //editPropStep2: "",
                //editPowerStep2: 0,
                //editVoltageStep2: 380,
                //editResponsibleUserUidStep2: "",
                //editResSubstationUidStep2: "",
                //editResFeederUidStep2: "",
                //editResTrSubstationUidStep2: "",

                editDataJsonStep2: {
                    ResponsibleUser_UID: "",
                    Description: "",
                    Prop: "",
                    Power: 0,
                    Voltage: 380,
                    RESSubstation_UID: "",
                    RESFeeder_UID: "",
                    RESTrSubstation_UID: "",
                },

                editResponsibleUsersStep2: [],
                editResSubstationsStep2: [],
                editResFeedersStep2: [],
                editResTrSubstationsStep2: [],

                //Step3
                //editResponsibleUserUidStep3: "",
                //editDescriptionStep3: "",

                editDataJsonStep3: {
                    ResponsibleUser_UID: "",
                    Description: "",
                },
                editResponsibleUsersStep3: [],
                attachmentsStep3: [],
                attachmentParamsStep3: {},

                //Step4
                //editResponsibleUserUidStep4: "",
                //editDescriptionStep4: "",
                editDataJsonStep4: {
                    ResponsibleUser_UID: "",
                    Description: "",
                },

                editResponsibleUsersStep4: [],
                attachmentsStep4: [],
                attachmentParamsStep4: {},

                //Step5
                editDescriptionStep5: "",
                editResponsibleUserUidStep5: "",
                editDataJsonStep5: {
                    ResponsibleUser_UID: "",
                    Description: "",
                },

                editResponsibleUsersStep5: [],

                //Step6
                //editSealCapStep6: "",
                //editSealBoxStep6: "",
                //editTransformationCoefficientStep6: 1,
                //editSealOneOffStep6: "",
                //editSealTTStep6: "",
                //editSealTTShieldStep6: "",
                //editSealTNShieldStep6: "",
                //editSealRTStep6: "",
                //editSealABTNStep6: "",
                //editDescriptionStep6: "",
                //editResponsibleUserUidStep6: "",
                //editSrpuRpDeviceUidStep6: "",

                editDataJsonStep6: {
                    ResponsibleUser_UID: "",
                    Description: "",
                    RPDevice_UID: "",
                    SealCap: "",
                    SealBox: "",
                    TransformationCoefficient: 1,
                    SealOneOff: "",
                    SealTT: "",
                    SealTTShield: "",
                    SealTNShield: "",
                    SealRT: "",
                    SealABTN: "",
                },

                editResponsibleUsersStep6: [],
                attachmentsStep6: [],
                editSrpuRpDevicesStep6: [],
                attachmentParamsStep6: {},

                //Step7
                //editDescriptionStep7: "",
                //editSubscriberRateUidStep7: "",
                editDataJsonStep7: {
                    SubscriberRate_UID: "",
                    Description: "",
                },

                editSubscriberRatesStep7: [],

                fileDownloadCounter: 0,

                stepWizard: [
                    {"step": -1, "title": "Заявка"},
                    {"step": 1, "title": "Заявка у руководства РЭС"},
                    {"step": 2, "title": "Заявка у начальника участка"},
                    {"step": 3, "title": "Главный инженер"},
                    {"step": 4, "title": "Инженер ЦОН"},
                    {"step": 5, "title": "Заявка у мастера ПУ"},
                    {"step": 6, "title": "Заявка у монтера ПУ"},
                    {"step": 7, "title": "СДиВК"},
                ],
                step: -1,

            }
        },
        created() {
            if ("uid" in this.$route.query && this.$route.query.uid !== "") {
                this.recordUid = this.$route.query.uid
                this.getRecord()
            } else {
                this.addEditTitle = "Добавление записи"
                this.addEditSubTitle = ""
            }

            this.userActionAccessArray = this.getUserActionAccessArray("DocsNewSubscriber", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
            this.userActionAccessRes = this.getUserDataAccess("RefsRES", this.userData.UserAccess)
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Документы", route: "new-subscriber"},
                {title: "Новый абонент"}
            ]);

            if (this.userData.UserGroupUid === 1) this.loadCompanies()
            if (this.userData.UserGroupUid !== 1) this.loadRes()
            if (this.recordUid.length === 0 && !this.userActionAccessRes) this.loadResponsibleUsers()

            if (this.userActionAccessCompany) {
                this.$nextTick(() => {
                    this.$refs.selectEditCompany.$el.focus()
                })
            } else if (this.userActionAccessRes) {
                this.$nextTick(() => {
                    this.$refs.selectEditRes.$el.focus()
                })
            }
        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            loadCompanies() {
                this.editCompanies = []

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.editCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRes() {
                this.editRes = []

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            this.editRes = []
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.", "danger", true)
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editRes.push({
                                                'value': item.UID,
                                                'text': item.RES
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString(), "danger", true)
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            loadResponsibleUsers() {
                this.errTextHide()

                this.editResponsibleUsers = []

                let data = {}
                if (this.userActionAccessRes) {
                    data = {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                        'F_RES_UID': this.editResUid,
                        'F_RegistrationType_UID': this.recordRegistrationTypeUid,
                    }
                } else {
                    data = {
                        'Session_UID': this.userData.Session_UID,
                        'F_RegistrationType_UID': this.recordRegistrationTypeUid,
                    }
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetResponsibleUsersForNewSubscriberRegistration", data,
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.", "danger", true)
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editResponsibleUsers.push({
                                                'value': item.UID,
                                                'text': item.UserName
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString(), "danger", true)
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            loadResponsibleUsersRegistrationStep(step) {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetResponsibleUsersForNewSubscriberRegistrationStep", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                        'F_RegistrationStepIndex': step - 1,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.", "danger", true)
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        let arr = []
                                        result.forEach(item => {
                                            arr.push({
                                                'value': item.UID,
                                                'text': item.UserName
                                            })
                                        })

                                        if (step === 1)
                                            this.editResponsibleUsersStep1 = arr
                                        else if (step === 2)
                                            this.editResponsibleUsersStep2 = arr
                                        else if (step === 3)
                                            this.editResponsibleUsersStep3 = arr
                                        else if (step === 4)
                                            this.editResponsibleUsersStep4 = arr
                                        else if (step === 5)
                                            this.editResponsibleUsersStep5 = arr
                                        else if (step === 6)
                                            this.editResponsibleUsersStep6 = arr
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString(), "danger", true)
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            loadResSubstationsStep2() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESSubstationsArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                        'F_RES_UID': this.editResUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.", "danger", true)
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editResSubstationsStep2.push({
                                                'value': item.UID,
                                                'text': item.Substation
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString(), "danger", true)
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            loadResFeedersStep2() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESFeedersArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                        'F_RES_UID': this.editResUid,
                        'F_RESSubstation_UID': this.editDataJsonStep2.RESSubstation_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.", "danger", true)
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editResFeedersStep2.push({
                                                'value': item.UID,
                                                'text': item.Feeder
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString(), "danger", true)
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            loadResTrSubstationsStep2() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESTrSubstationsArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                        'F_RES_UID': this.editResUid,
                        'F_RESFeeder_UID': this.editDataJsonStep2.RESFeeder_UID
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.", "danger", true)
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editResTrSubstationsStep2.push({
                                                'value': item.UID,
                                                'text': item.TrSubstation
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString(), "danger", true)
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            loadSubscriberRatesStep7() {
                this.errTextHide()

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsSubscriberRatesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.editCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.", "danger", true)
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.editSubscriberRatesStep7.push({
                                                'value': item.UID,
                                                'text': item.Rate
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString(), "danger", true)
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            saveRecord() {
                this.errTextHide()

                if (!this.checkValidationRecord()) return

                this.loadProcessing++
                axios.post("/ws/ws.svc/UpdateDocsNewSubscriberRegistration", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_Company_UID': this.editCompanyUid,
                        'R_RES_UID': this.editResUid,
                        'R_RegistrationType_UID': this.recordRegistrationTypeUid,
                        'R_ResponsibleUser_UID': this.editResponsibleUserUid,
                        'R_Subscriber': this.editSubscriber,
                        'R_Address': this.editAddress,
                        'R_PhoneNumbers': this.editPhoneNumbers,
                        'R_Description': this.editDescription,
                        'R_RS': this.editRegistrationStatusUid,
                        'R_RV': this.recordVersion,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                            || this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.showMessageRecordSaved()
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))
                                    this.recordUid = result.UID.toString() || ""
                                    this.recordVersion = result.RVV.toString() || ""
                                    this.editDocBlankUid = parseInt(result.DocBlank_UID.toString() || "-1")
                                    this.getRecord()
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            saveRecordStep() {
                this.errTextHide()

                if (!this.checkValidationRecordStep()) return

                let dataJson = {}
                if (this.step === 1) dataJson = this.editDataJsonStep1
                else if (this.step === 2) dataJson = this.editDataJsonStep2
                else if (this.step === 3) dataJson = this.editDataJsonStep3
                else if (this.step === 4) dataJson = this.editDataJsonStep4
                else if (this.step === 5) dataJson = this.editDataJsonStep5
                else if (this.step === 6) dataJson = this.editDataJsonStep6
                else if (this.step === 7) dataJson = this.editDataJsonStep7

                let sti = this.editRegistrationStepIndex
                if (sti !== -1) sti--

                this.loadProcessing++
                axios.post("/ws/ws.svc/UpdateDocsNewSubscriberRegistrationStep", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_RegistrationStepIndex': sti,
                        'R_DataJson': JSON.stringify(dataJson),
                        'R_RV': this.recordVersion,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                            || this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.showMessageRecordSaved()
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))
                                    this.recordVersion = result.RVV.toString() || ""
                                    this.getRecord()
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            checkValidationRecord() {
                let result = true
                if (this.userData.UserGroupUid === 1 && this.editCompanyUid === 0) {
                    this.errTextShow("Выберите РЭК.", "info", true)
                    result = false
                } else if (this.userActionAccessRes && this.editResUid === "") {
                    this.errTextShow("Выберите РЭС.", "info", true)
                    result = false
                } else if (this.editResponsibleUserUid === "") {
                    this.errTextShow("Выберите Ответственного сотрудника.", "info", true)
                    result = false
                } else if (this.editSubscriber.trim() === "") {
                    this.errTextShow("Введите Заявителя.", "info", true)
                    result = false
                } else if (this.editPhoneNumbers.trim() === "") {
                    this.errTextShow("Введите Телефон(ы).", "info", true)
                    result = false
                } else if (this.editAddress.trim() === "") {
                    this.errTextShow("Введите Адрес.", "info", true)
                    result = false
                }

                return result
            },
            checkValidationRecordStep() {
                let result = true

                if (this.step === 1) {
                    if (this.editDataJsonStep1.ResponsibleUser_UID === "") {
                        this.errTextShow("Выберите Ответственного сотрудника.", "info", true)
                        result = false
                    }
                } else if (this.step === 2) {
                    if (this.editDataJsonStep2.ResponsibleUser_UID === "") {
                        this.errTextShow("Выберите Ответственного сотрудника.", "info", true)
                        result = false
                    } else if (this.editDataJsonStep2.RESTrSubstation_UID === "") {
                        this.errTextShow("Выберите ТП РЭС.", "info", true)
                        result = false
                    } else if (this.editDataJsonStep2.Prop.toString().trim() === "") {
                        this.errTextShow("Введите Опору.", "info", true)
                        result = false
                    } else if (this.editDataJsonStep2.Power.toString().trim() === "" ||
                        !this.isInteger(this.editDataJsonStep2.Power) || parseInt(this.editDataJsonStep2.Power) < 1) {
                        this.errTextShow("Введите числовое значение Мощности больше нуля.", "info", true)
                        result = false
                    } else if (this.editDataJsonStep2.Voltage.toString().trim() === "" ||
                        !this.isInteger(this.editDataJsonStep2.Voltage)) {
                        this.errTextShow("Введите числовое значение Напряжения.", "info", true)
                        result = false
                    }
                } else if (this.step === 3) {
                    if (this.editDataJsonStep3.ResponsibleUser_UID === "") {
                        this.errTextShow("Выберите Ответственного сотрудника.", "info", true)
                        result = false
                    }
                } else if (this.step === 4) {
                    if (this.editDataJsonStep4.ResponsibleUser_UID === "") {
                        this.errTextShow("Выберите Ответственного сотрудника.", "info", true)
                        result = false
                    }
                } else if (this.step === 5) {
                    if (this.editDataJsonStep5.ResponsibleUser_UID === "") {
                        this.errTextShow("Выберите Ответственного сотрудника.", "info", true)
                        result = false
                    }
                } else if (this.step === 6) {
                    let tc = this.editDataJsonStep6.TransformationCoefficient

                    if (this.editDataJsonStep6.ResponsibleUser_UID === "") {
                        this.errTextShow("Выберите Ответственного сотрудника.", "info", true)
                        result = false
                    } else if (this.editDataJsonStep6.RPDevice_UID === "") {
                        this.errTextShow("Выберите ПУ.", "info", true)
                        result = false
                    } else if (this.editDataJsonStep6.SealCap.toString().trim() === "") {
                        this.errTextShow("Введите Пломбу крышки.", "info", true)
                        result = false
                    } else if (tc.toString().trim() === "" || !this.isInteger(tc) || tc < 1 || tc > 10000) {
                        this.errTextShow("Введите Коэффициент трансформации в диапазоне от 1 до 10000.", "info", true)
                        result = false
                    }
                } else if (this.step === 7) {
                    if (this.editDataJsonStep7.SubscriberRate_UID === "") {
                        this.errTextShow("Выберите Тариф абонента.", "info", true)
                        result = false
                    }
                }

                return result
            },
            cancelRecord() {
                this.$router.push({name: 'documents-new-subscriber', query: {returnFromUpdate: true}})
            },
            showMessageRecordSaved() {
                clearTimeout(this.editRecordSavedMessageTimer)
                this.editRecordSavedMessage = "Запись сохранена"
                this.editRecordSavedMessageTimer = setTimeout(() => {
                    this.editRecordSavedMessage = "";
                }, 5000);
            },
            generateBlank(lang) {
                //if (this.recordUid === "") return

                let routeData = this.$router.resolve({
                    path: '/blank-new-subscriber',
                    query: {
                        sessionUid: this.userData.Session_UID,
                        recordUid: this.recordUid,
                        docBlankUid: this.editDocBlankUid,
                        lang: lang
                    }
                })
                window.open(routeData.href, '_blank')
            },
            selectEditResChanged() {
                this.$refs.selectEditResponsibleUser.$el.focus()
                this.loadResponsibleUsers()
            },
            selectEditResponsibleUserChanged() {
                this.$refs.inputEditSubscriber.$el.focus()
            },
            getDownloadStatus(p) {
                (!this.isUndefined(p.status) && p.status) ? this.fileDownloadCounter++ : this.fileDownloadCounter--
            },
            getRecord() {
                this.errTextHide()

                this.editResponsibleUsers = []
                this.editResponsibleUsersStep1 = []
                this.editResponsibleUsersStep2 = []
                this.editResponsibleUsersStep3 = []
                this.editResponsibleUsersStep4 = []
                this.editResponsibleUsersStep5 = []
                this.editResponsibleUsersStep6 = []
                this.editResSubstationsStep2 = []
                this.editResFeedersStep2 = []
                this.editResTrSubstationsStep2 = []
                this.editSubscriberRatesStep7 = []

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetDocsNewSubscriberRegistration", {
                        'Session_UID': this.userData.Session_UID,
                        'F_UID': this.recordUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    let result = (JSON.parse(resp.data.data))

                                    this.editCompanyUid = result.Company_UID ? parseInt(result.Company_UID.toString()) : 0
                                    this.editResUid = result.RES_UID ? result.RES_UID.toString() : ""
                                    this.editSubscriber = result.Subscriber.toString()
                                    this.editAddress = result.Address.toString()
                                    this.editPhoneNumbers = result.PhoneNumbers.toString()
                                    this.editRegistrationNum = result.RegistrationNum.toString()
                                    this.editFullRegistrationNum = result.FullRegistrationNum.toString()
                                    this.editDescription = result.Description.toString()
                                    this.editRegistrationStatusUid = parseInt(result.RegistrationStatus_UID.toString())
                                    this.editDocBlankUid = parseInt(result.DocBlank_UID.toString())
                                    this.editRegistrationStepUid = parseInt(result.RegistrationStep_UID.toString())
                                    this.editResponsibleUserUid = result.ResponsibleUser_UID.toString()
                                    this.editRegistrationType = result.RegistrationType.toString()
                                    this.userActionStepSwitchAccess = (result.StepSwitchAccess.toString() === "1")
                                    this.userActionStepEditAccess = (result.StepEditAccess.toString() === "1")
                                    this.recordVersion = result.RVV.toString()

                                    this.editRegistrationStepIndex = parseInt(result.RegistrationStepIndex.toString())
                                    if (this.editRegistrationStepIndex !== -1)
                                        this.editRegistrationStepIndex++
                                    this.step = this.editRegistrationStepIndex

                                    if (this.step === -1) {
                                        this.loadResponsibleUsers()
                                    } else {
                                        this.editResponsibleUsers.push({
                                            'value': result.ResponsibleUser_UID,
                                            'text': result.ResponsibleUser
                                        })
                                    }

                                    if (this.step >= 1 && this.step !== 7) this.loadResponsibleUsersRegistrationStep(this.step)
                                    if (this.step === 2) {
                                        this.loadResSubstationsStep2()
                                        this.loadResFeedersStep2()
                                        this.loadResTrSubstationsStep2()
                                    }
                                    if (this.step === 7) this.loadSubscriberRatesStep7()

                                    //update Attachments
                                    this.attachments = result.Attachments

                                    //Load steps
                                    if (!this.isUndefined(result.Steps.Step1)) {
                                        this.editDataJsonStep1.ResponsibleUser_UID = result.Steps.Step1.ResponsibleUser_UID.toString() || ""
                                        this.editDataJsonStep1.Description = result.Steps.Step1.Description.toString() || ""

                                        if (this.step !== 1) {
                                            this.editResponsibleUsersStep1.push({
                                                'value': result.Steps.Step1.ResponsibleUser_UID,
                                                'text': result.Steps.Step1.ResponsibleUser
                                            })
                                        }
                                    }
                                    if (!this.isUndefined(result.Steps.Step2)) {
                                        this.editDataJsonStep2.Prop = result.Steps.Step2.Prop.toString() || ""
                                        this.editDataJsonStep2.Power = parseInt(result.Steps.Step2.Power.toString()) || 0
                                        this.editDataJsonStep2.Voltage = parseInt(result.Steps.Step2.Voltage.toString()) || 0
                                        this.editDataJsonStep2.ResponsibleUser_UID = result.Steps.Step2.ResponsibleUser_UID.toString() || ""
                                        this.editDataJsonStep2.Description = result.Steps.Step2.Description.toString() || ""
                                        this.editDataJsonStep2.RESSubstation_UID = result.Steps.Step2.RESSubstation_UID.toString() || ""
                                        this.editDataJsonStep2.RESFeeder_UID = result.Steps.Step2.RESFeeder_UID.toString() || ""
                                        this.editDataJsonStep2.RESTrSubstation_UID = result.Steps.Step2.RESTrSubstation_UID.toString() || ""

                                        if (this.step !== 2) {
                                            this.editResponsibleUsersStep2.push({
                                                'value': result.Steps.Step2.ResponsibleUser_UID,
                                                'text': result.Steps.Step2.ResponsibleUser
                                            })
                                            this.editResSubstationsStep2.push({
                                                'value': result.Steps.Step2.RESSubstation_UID,
                                                'text': result.Steps.Step2.Substation
                                            })
                                            this.editResFeedersStep2.push({
                                                'value': result.Steps.Step2.RESFeeder_UID,
                                                'text': result.Steps.Step2.Feeder
                                            })
                                            this.editResTrSubstationsStep2.push({
                                                'value': result.Steps.Step2.RESTrSubstation_UID,
                                                'text': result.Steps.Step2.TrSubstation
                                            })
                                        }
                                    }
                                    if (!this.isUndefined(result.Steps.Step3)) {
                                        this.editDataJsonStep3.ResponsibleUser_UID = result.Steps.Step3.ResponsibleUser_UID.toString() || ""
                                        this.editDataJsonStep3.Description = result.Steps.Step3.Description.toString() || ""
                                        this.attachmentsStep3 = result.Steps.Step3.Attachments

                                        if (this.step !== 3) {
                                            this.editResponsibleUsersStep3.push({
                                                'value': result.Steps.Step3.ResponsibleUser_UID,
                                                'text': result.Steps.Step3.ResponsibleUser
                                            })
                                        }
                                    }
                                    if (!this.isUndefined(result.Steps.Step4)) {
                                        this.editDataJsonStep4.ResponsibleUser_UID = result.Steps.Step4.ResponsibleUser_UID.toString() || ""
                                        this.editDataJsonStep4.Description = result.Steps.Step4.Description.toString() || ""
                                        this.attachmentsStep4 = result.Steps.Step4.Attachments

                                        if (this.step !== 4) {
                                            this.editResponsibleUsersStep4.push({
                                                'value': result.Steps.Step4.ResponsibleUser_UID,
                                                'text': result.Steps.Step4.ResponsibleUser
                                            })
                                        }
                                    }
                                    if (!this.isUndefined(result.Steps.Step5)) {
                                        this.editDataJsonStep5.ResponsibleUser_UID = result.Steps.Step5.ResponsibleUser_UID.toString() || ""
                                        this.editDataJsonStep4.Description = result.Steps.Step5.Description.toString() || ""

                                        if (this.step !== 5) {
                                            this.editResponsibleUsersStep5.push({
                                                'value': result.Steps.Step5.ResponsibleUser_UID,
                                                'text': result.Steps.Step5.ResponsibleUser
                                            })
                                        }
                                    }
                                    if (!this.isUndefined(result.Steps.Step6)) {
                                        this.editSrpuRpDevicesStep6 = [
                                            {
                                                "UID": result.Steps.Step6.RPDevice_UID.toString() || "",
                                                "Device": result.Steps.Step6.RPDevice.toString() || "",
                                            }
                                        ]

                                        this.editDataJsonStep6.ResponsibleUser_UID = result.Steps.Step6.ResponsibleUser_UID.toString() || ""
                                        this.editDataJsonStep6.Description = result.Steps.Step6.Description.toString() || ""
                                        this.editDataJsonStep6.RPDevice_UID = result.Steps.Step6.RPDevice_UID.toString() || ""
                                        this.editDataJsonStep6.SealCap = result.Steps.Step6.SealCap.toString() || ""
                                        this.editDataJsonStep6.SealBox = result.Steps.Step6.SealBox.toString() || ""
                                        this.editDataJsonStep6.TransformationCoefficient = parseInt(result.Steps.Step6.TransformationCoefficient.toString()) || 0
                                        this.editDataJsonStep6.SealOneOff = result.Steps.Step6.SealOneOff.toString() || ""
                                        this.editDataJsonStep6.SealTT = result.Steps.Step6.SealTT.toString() || ""
                                        this.editDataJsonStep6.SealTTShield = result.Steps.Step6.SealTTShield.toString() || ""
                                        this.editDataJsonStep6.SealTNShield = result.Steps.Step6.SealTNShield.toString() || ""
                                        this.editDataJsonStep6.SealRT = result.Steps.Step6.SealRT.toString() || ""
                                        this.editDataJsonStep6.SealABTN = result.Steps.Step6.SealABTN.toString() || ""
                                        this.attachmentsStep6 = result.Steps.Step6.Attachments

                                        if (this.step !== 6) {
                                            this.editResponsibleUsersStep6.push({
                                                'value': result.Steps.Step6.ResponsibleUser_UID,
                                                'text': result.Steps.Step6.ResponsibleUser
                                            })
                                        }
                                    }
                                    if (!this.isUndefined(result.Steps.Step7)) {
                                        this.editDataJsonStep7.SubscriberRate_UID = result.Steps.Step7.SubscriberRate_UID.toString() || ""
                                        this.editDataJsonStep7.Description = result.Steps.Step7.Description.toString() || ""

                                        if (this.step !== 7) {
                                            this.editSubscriberRatesStep7 = [
                                                {
                                                    "UID": result.Steps.Step7.SubscriberRate_UID.toString() || "",
                                                    "Rate": result.Steps.Step7.SubscriberRate.toString() || "",
                                                }
                                            ]
                                        }
                                    }

                                    if (this.userActionAccessArray["edit"]) {
                                        this.addEditTitle = `Изменение записи: ${this.editSubscriber}`
                                        this.addEditSubTitle = `${this.editRegistrationType}, №${this.editFullRegistrationNum}`
                                    } else {
                                        this.addEditTitle = `Просмотр записи: ${this.editSubscriber}`
                                        this.addEditSubTitle = `${this.editRegistrationType}, №${this.editFullRegistrationNum}`
                                    }
                                } else {
                                    this.errTextShow("Запись не найдена. Пожалуйста, обновите страницу.", "danger", true)
                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.loadProcessing--

                        if (this.userActionAccessCompany) {
                            this.$nextTick(() => {
                                this.$refs.selectEditCompany.$el.focus()
                            })
                        } else if (this.userActionAccessRes) {
                            this.$nextTick(() => {
                                this.$refs.selectEditRes.$el.focus()
                            })
                        }
                    })
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                    })
            },
            selectEditResSubstationsChanged() {
                this.editResTrSubstationsStep2 = []
                this.editResFeedersStep2 = []
                this.editResTrSubstationUidStep2 = ""
                this.editResFeederUidStep2 = ""

                this.loadResFeedersStep2()
            },
            selectEditResFeedersChanged() {
                this.editResTrSubstationsStep2 = []
                this.editResTrSubstationUidStep2 = ""

                this.loadResTrSubstationsStep2()
            },
            stepChanged(step) {
                this.errTextHide()
                this.editRecordSavedMessage = "";
                this.step = step
            },
            switchToNextStep() {
                this.errTextHide()

                let dataJson = {}

                if (!this.checkValidationRecordStep()) return

                if (this.step === 1) dataJson = this.editDataJsonStep1
                else if (this.step === 2) dataJson = this.editDataJsonStep2
                else if (this.step === 3) dataJson = this.editDataJsonStep3
                else if (this.step === 4) dataJson = this.editDataJsonStep4
                else if (this.step === 5) dataJson = this.editDataJsonStep5
                else if (this.step === 6) dataJson = this.editDataJsonStep6
                else if (this.step === 7) dataJson = this.editDataJsonStep7

                let sti = this.editRegistrationStepIndex
                if (sti !== -1) sti--

                axios.post("/ws/ws.svc/SwitchDocsNewSubscriberRegistrationToNextStep", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_RegistrationStepIndex': sti,
                        'R_DataJson': JSON.stringify(dataJson),
                        'R_RV': this.recordVersion,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    this.$refs['modal-finished'].show()
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            switchToPreviousStep() {
                this.errTextHide()

                let description = ""
                if (this.step === 1) description = this.editDataJsonStep1.Description
                else if (this.step === 2) description = this.editDataJsonStep2.Description
                else if (this.step === 3) description = this.editDataJsonStep3.Description
                else if (this.step === 4) description = this.editDataJsonStep4.Description
                else if (this.step === 5) description = this.editDataJsonStep5.Description
                else if (this.step === 6) description = this.editDataJsonStep6.Description
                else if (this.step === 7) description = this.editDataJsonStep7.Description

                let dataJson = {"Description": description}

                let sti = this.editRegistrationStepIndex
                if (sti !== -1) sti--

                axios.post("/ws/ws.svc/SwitchDocsNewSubscriberRegistrationToPreviousStep", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_RegistrationStepIndex': sti,
                        'R_RV': this.recordVersion,
                        'R_DataJson': JSON.stringify(dataJson),
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    this.cancelRecord()
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            cancelStep() {
                this.errTextHide()

                let description = ""
                if (this.step === 1) description = this.editDataJsonStep1.Description
                else if (this.step === 2) description = this.editDataJsonStep2.Description
                else if (this.step === 3) description = this.editDataJsonStep3.Description
                else if (this.step === 4) description = this.editDataJsonStep4.Description
                else if (this.step === 5) description = this.editDataJsonStep5.Description
                else if (this.step === 6) description = this.editDataJsonStep6.Description
                else if (this.step === 7) description = this.editDataJsonStep7.Description

                let dataJson = {"Description": description}

                let sti = this.editRegistrationStepIndex
                if (sti !== -1) sti--

                this.loadProcessing++
                axios.post("/ws/ws.svc/RejectDocsNewSubscriberRegistration", {
                        'Session_UID': this.userData.Session_UID,
                        'R_UID': this.recordUid,
                        'R_RegistrationStepIndex': sti,
                        'R_Description': description,
                        'R_RV': this.recordVersion,
                        'R_DataJson': JSON.stringify(dataJson),
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                            || this.isUndefined(resp.data.data)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                this.cancelRecord()
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }

                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },
            buttonNextStepClicked() {
                this.errTextHide()
                this.$refs['modal-next-step-confirmation'].show()
            },
            buttonCloseStepClicked() {
                this.errTextHide()
                this.$refs['modal-close-step-confirmation'].show()
            },
            buttonPreviousStepClicked() {
                this.errTextHide()
                if ((this.step === 1 && this.editDataJsonStep1.Description.trim() === "") ||
                    (this.step === 2 && this.editDataJsonStep2.Description.trim() === "") ||
                    (this.step === 3 && this.editDataJsonStep3.Description.trim() === "") ||
                    (this.step === 4 && this.editDataJsonStep4.Description.trim() === "") ||
                    (this.step === 5 && this.editDataJsonStep5.Description.trim() === "") ||
                    (this.step === 6 && this.editDataJsonStep6.Description.trim() === "") ||
                    (this.step === 7 && this.editDataJsonStep7.Description.trim() === "")
                ) {
                    this.errTextShow("Перед возвратом заявки на предыдущий шаг в поле 'Примечание' введите причину возврата.", "info", true)
                    return
                }

                this.$refs['modal-previous-step-confirmation'].show()
            },
            buttonCancelStepClicked() {
                this.errTextHide()
                if ((this.step === -1 && this.editDescription.toString().trim() === "") ||
                    (this.step === 1 && this.editDataJsonStep1.Description.trim() === "") ||
                    (this.step === 2 && this.editDataJsonStep2.Description.trim() === "") ||
                    (this.step === 3 && this.editDataJsonStep3.Description.trim() === "") ||
                    (this.step === 4 && this.editDataJsonStep4.Description.trim() === "") ||
                    (this.step === 5 && this.editDataJsonStep5.Description.trim() === "") ||
                    (this.step === 6 && this.editDataJsonStep6.Description.trim() === "") ||
                    (this.step === 7 && this.editDataJsonStep7.Description.trim() === "")
                ) {
                    this.errTextShow("Перед отклонением заявки в поле 'Примечание' введите причину отклонения.", "info", true)
                    return
                }

                this.$refs['modal-cancel-step-confirmation'].show()
            },
            buttonNextStepConfirmCancelClicked() {
                this.$refs['modal-next-step-confirmation'].hide()
            },
            buttonNextStepConfirmOkClicked() {
                this.switchToNextStep()
                this.$refs['modal-next-step-confirmation'].hide()
            },
            buttonCloseStepConfirmCancelClicked() {
                this.$refs['modal-close-step-confirmation'].hide()
            },
            buttonCloseStepConfirmOkClicked() {
                this.switchToNextStep()
                this.$refs['modal-close-step-confirmation'].hide()
            },
            buttonPreviousStepConfirmOkClicked() {
                this.switchToPreviousStep()
                this.$refs['modal-previous-step-confirmation'].hide()
            },
            buttonPreviousStepConfirmCancelClicked() {
                this.$refs['modal-previous-step-confirmation'].hide()
            },
            buttonCancelStepConfirmOkClicked() {
                this.cancelStep()
                this.$refs['modal-cancel-step-confirmation'].hide()
            },
            buttonCancelStepConfirmCancelClicked() {
                this.$refs['modal-cancel-step-confirmation'].hide()
            },
            loadSrpuRpDevices: debounce((loading, search, vm) => {
                vm.editSrpuRpDevicesStep6 = []

                axios.post("/ws/ws.svc/GetDocsSRPURPDevicesArray", {
                        'Session_UID': vm.userData.Session_UID,
                        'F_Company_UID': vm.editCompanyUid,
                        'F_QuickFilter': search,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (!vm.isUndefined(resp.data.success) && !vm.isUndefined(resp.data.response) &&
                            !vm.isUndefined(resp.data.data)) {
                            if (resp.data.success) {

                                if (resp.data.data.toString().length > 0) {
                                    vm.editSrpuRpDevicesStep6 = JSON.parse(resp.data.data)

                                }
                            } else {
                                vm.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        } else {
                            vm.errTextShow("Неверный формат ответа.", "danger", true)
                        }
                        if (loading) loading(false);
                    })
                    .catch(err => {
                        if (loading) loading(false);
                    })
            }, 350),
            fetchSrpuRpDevices(search, loading) {
                if (search.length) {
                    loading(true)
                    this.loadSrpuRpDevices(loading, search, this)
                }
            },
        },
        computed: {
            getEditControlStatus: function () {
                return (!this.userActionAccessArray["edit"] || this.editRegistrationStepIndex !== this.step ||
                    this.editRegistrationStatusUid === 6 || this.editRegistrationStatusUid === 11 ||
                    (this.step !== -1 && !this.userActionStepEditAccess)
                )
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>
    .select2 {
        height: calc(1.5em + 1.3rem + 2px);
        margin-top: -2px;
    }

    /deep/ .select2 .vs__dropdown-toggle {
        height: calc(1.5em + 1.3rem + 2px);
    }

    /deep/ .card-subtitle {
        margin-top: -1.5rem;
        font-size: 1rem;
    }
</style>